<template>
  <!--内容部分 start-->
  <div class="container-page">
    <!-- 上面部分 -->
    <div class="container-top">
      <!-- 标题 -->
      <div class="container-top-title">你好，{{ come.agent.name }}</div>
      <!-- 交易金额 -->
      <div class="container-top-money">
        <div class="container-top-money-title">交易金额</div>
        <div class="container-top-money-cell">
          <div :class="time == 1 ? 'active' : ''" class="container-top-money-item" @click="timeHandel(1)">今日</div>
          <div :class="time == 2 ? 'active' : ''" class="container-top-money-item" @click="timeHandel(2)">本月</div>
          <div :class="time == 3 ? 'active' : ''" class="container-top-money-item" @click="timeHandel(3)">所有</div>
        </div>
      </div>
      <!-- 金额 -->
      <div v-if="time == 1" class="container-top-money-num">￥ {{ formatAmount(come.agent.today_fee) }}</div>
      <div v-if="time == 2" class="container-top-money-num">￥ {{ formatAmount(come.agent.month_fee) }}</div>
      <div v-if="time == 3" class="container-top-money-num">￥ {{ formatAmount(come.agent.total_fee) }}</div>
      <!-- 数据 -->
      <div class="container-top-money-data">
        <div class="container-top-money-data-item" @click="merchant_info">
          <div>商户总数</div>
          <div class="income">{{ come.merchantNum }}</div>
        </div>
        <div class="container-top-money-data-item" @click="salesman_info" v-if="come.agent.agent_type == 0">
          <div>业务员总数</div>
          <div class="income">{{ come.salesmanNum }}</div>
        </div>
        <div class="container-top-money-data-item" v-if="come.agent.agent_type == 1" @click="partner_info()">
          <div>合作伙伴</div>
          <div class="income">{{ come.agent.partner_num }}</div>
        </div>
      </div>
    </div>
    <!-- 菜单 -->
    <div class="menu-data" style="margin-top: 1.6rem" v-if="come.agent.agent_type == 0">
      <div class="menu-item" v-for="(item, index) in menu_data" :key="index" @click="menu_info(item)">
        <div>
          <img class="menu-item-img" :src="item.menu_img" alt="" />
        </div>
        <div class="menu-item-text">{{ item.menu_text }}</div>
      </div>
    </div>
    <div style="margin-top: 1.6rem" v-if="come.agent.agent_type == 1"></div>
    <!-- 数据分析 -->
    <div class="data-analysis">
      <div class="data-analysis-top" style="margin-top: 0.6rem">
        <div class="tb_title">
          <div class="tb_title_dot"></div>
          30天新进商户分析
        </div>
        <line-charts :chart-data="lineChartDatas" />
      </div>
      <div class="data-analysis-bot" style="margin-top: 0.6rem">
        <div class="tb_title">
          <div class="tb_title_dot"></div>
          商户活跃度分析
        </div>
        <pie-chart />
      </div>
    </div>
  </div>
  <!--内容部分 end-->
</template>

<script>
import LineCharts from './LineChartss'
import PieChart from './Business'
// 菜单图片
import merchant_information from '../../assets/images/merchant_information.png' // 商户信息
import merchant_information_6 from '../../assets/images/6.png' // 商户信息
import AgentMerchantFlow from '../../assets/images/transaction_flow.png' // 交易流水
import AgentMerchantFlow_num from '../../assets/images/3.png' // 交易汇总
import MerchantStoreSummary from '../../assets/images/express_collection.png' // 交易汇总
import collection_code from '../../assets/images/03.png' // 下级服务商
import express_collection from '../../assets/images/01.png' // 业务员管理
import express_collection_2 from '../../assets/images/02.png' // 商户管理
import express_collection_5 from '../../assets/images/5.png' // 快捷收款
export default {
  name: 'AgentHomepage', // 服务商首页
  components: {
    LineCharts,
    PieChart
  },
  data() {
    return {
      time: 1, // 默认显示今日
      come: '', // 服务商信息
      menu_data: [
        // {
        //   'menu_text': '服务商信息',
        //   'menu_img': merchant_information,
        //   'menu_url': '/AgentInfomation'
        // },
        // {
        //   'menu_text': '我的账户',
        //   'menu_img': merchant_information_6,
        //   'menu_url': '/MyAccount'
        // },
        // {
        //   'menu_text': '数据分析',
        //   'menu_img': express_collection_5,
        //   'menu_url': '/AgentAnalysis'
        // },
        {
          'menu_text': '商户管理',
          'menu_img': express_collection_2,
          'menu_url': '/MerchantManagement'
        },
        {
          'menu_text': '下级服务商',
          'menu_img': collection_code,
          'menu_url': '/AgentManagement'
        },
        {
          'menu_text': '业务员管理',
          'menu_img': express_collection,
          'menu_url': '/SalesmanManagement'
        },
        // {
        //   'menu_text': '交易汇总',
        //   'menu_img': AgentMerchantFlow_num,
        //   'menu_url': '/AgentMerchantCollect'
        // },
        // {
        //   'menu_text': '交易流水',
        //   'menu_img': AgentMerchantFlow,
        //   'menu_url': '/AgentMerchantFlow'
        // },

        // {
        //   'menu_text': '交易日报',
        //   'menu_img': MerchantStoreSummary,
        //   'menu_url': '/MerchantStoreSummary'
        // }

      ]
    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },
  mounted() {
    // 服务商信息
    this.income()
  },
  methods: {
    // 格式化金额
    formatAmount(money) {
      // 将输入的金额字符串转换为数字类型
      let number = parseFloat(money.replace(/,/g, ''));
      // 将数字转换为字符串，并格式化为每三位添加一个逗号
      return number.toLocaleString();
    },

    // 金额切换
    timeHandel(val) {
      this.time = val
    },
    // 收入金额
    income() {
      this.$http.get('/wechat/api.agent.index/info').then(response => {
        this.come = response.data.msg
     })
    },
    // 菜单跳转
    menu_info(item) {
      this.$router.push(item.menu_url)
    },
    // 合作伙伴跳转
    partner_info(){
      this.$router.push('/AgentManagement')
    },
    // 商户信息
    merchant_info() {
      this.$router.push('/MerchantManagement')
    },
    // 业务员信息
    salesman_info() {
      this.$router.push('/SalesmanManagement')
    }
  }
}
</script>

<style scoped lang="less">
.active {
  background-color: rgba(18, 118, 221, 0.996078431372549);
}

.container-page {
  width: 100%;
  height: 100%;
}

.container-top {
  width: 100%;
  height: 200px;
  background-color: rgba(20, 134, 251, 1);
  box-sizing: border-box;
  padding: 32px 16px;
}

.container-top-title {
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 2px;
  color: #FFFFFF;
  line-height: 50px;
  width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.container-top-money {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .container-top-money-title {
    font-weight: 700;
    letter-spacing: 2px;
    color: #FFFFFF;
    font-size: 16px;
    line-height: 40px;
  }

  .container-top-money-cell {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 162px;
    height: 24px;
    background-color: rgba(255, 255, 255, 0.3);
    border: none;
    border-radius: 16px;
    font-size: 12px;
    color: #FFFFFF;
    font-weight: 400;
  }

  .container-top-money-item {
    text-align: center;
    width: 54px;
    height: 24px;
    line-height: 24px;
    border-radius: 16px;
  }

}

.container-top-money-num {
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 2px;
  color: #FFFFFF;
  line-height: 40px;
}

.container-top-money-data {
  width: 100%;
  height: 86px;
  box-sizing: border-box;
  padding: 10px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.container-top-money-data-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.income {
  font-size: 18px;
  font-weight: 700;
}

.menu-data {
  box-sizing: border-box;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 86px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 12px;
  }

  .menu-item-img {
    width: 36px;
    height: 36px;
  }

  .menu-item-text {
    font-weight: 400;
    font-size: 14px;
    color: #333333;
  }

}

.data-analysis {
  width: 100%;
  box-sizing: border-box;
  padding: 0 16px;
}

.data-analysis-top {
  box-sizing: border-box;
  padding: 16px;
  height: 220px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.0784313725490196);
}

.data-analysis-bot {
  box-sizing: border-box;
  padding: 16px;
  height: 320px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 12px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.0784313725490196);
  margin-bottom: 50px;
}

.tb_title {
  color: #756e6e;
  font-size: 16px;
}

.tb_title_dot {
  background: #20a0ff;
  width: 5px;
  height: 12px;
  border-radius: 6px;
  display: inline-block;
}
</style>
